import { getQueryStringFromObject as a } from "@partoohub/utils";
import { ApiResourceBaseClass as r } from "./baseApiCalls.js";
const e = "publisher_states";
class u extends r {
  /**
   * Searching for publishers states based on a query string.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/publisher_state/search?${queryParams}`
   *
   * @param {BusinessModalFiltersType} queryParams
   * @returns {Promise<PublishersStateStatsResponse>}
   */
  getPublishersStates = async (s) => {
    const { data: t } = await this.get(
      `${e}/search?${a(s)}`
    );
    return t;
  };
  /**
   * Searching for publishers states based on a query string.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/publisher_state/businesses_info?${queryParams}`
   *
   * @param {BusinessModalFiltersType} queryParams
   * @returns {Promise<PublishersStatesBusinessesInfoData>}
   */
  getPublishersStatesBusinessesInfo = async (s) => {
    const { data: t } = await this.get(
      `${e}/businesses_info?${a(s)}`
    );
    return t;
  };
  /**
   * Searching for publishers states based on a query string.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/publisher_state/business_info?${queryParams}`
   *
   * @param {BusinessModalFiltersType} queryParams
   * @returns {Promise<PublishersStatesBusinessesInfoData>}
   */
  getPublishersStatesBusinessInfo = async (s) => {
    const { data: t } = await this.get(
      `${e}/business_info?${a(s)}`
    );
    return t;
  };
  /**
   * Searching for publishers states based on a query string.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/publisher_state/export`
   *
   * @param {string} email
   * @returns {Promise<Record<string, any>>}
   */
  postPublisherStatesExport = async (s) => {
    const { data: t } = await this.post(`${e}/export`, {
      email: s
    });
    return t;
  };
}
export {
  u as PublisherState
};
